/**
 * Created by Rodrigo Quesada on 09/04/17.
 */
import {Injectable} from '@angular/core';
import {UserModelService} from '../common/user-model.service';
import {Service} from '../common/service.class';
import {ProfileCompletion} from './profile-completion.model';


@Injectable()
export class ProfileCompletionService extends UserModelService<ProfileCompletion> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'profileCompletion', ProfileCompletion);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/completion/profile-completion.service.ts